// Product data transformation helpers

export function refactorProductInfo(productData) {
  if (!productData) return null

  return {
    // Basic product info
    id: productData.product_id,
    name: productData.product_name || '',
    usesAi: productData.product_uses_ai || false,
    active: productData.active ?? false,
    riskLevel: productData.risk_level || '',
    createdByAi: productData.created_by_ai || false,
    createdOn: productData.created_on || '',
    usesAiTimeStamp: productData.uses_ai_time_stamp || '',
    isTemplate:
      !productData.product_ai_assessment_qa || productData.product_ai_assessment_qa.length === 0,
    productAssessmentStatus: productData.product_ai_assessment_processing_status,
  }
}

export function refactorQaSection(qaData) {
  if (!qaData || !Array.isArray(qaData) || qaData.length === 0) {
    return []
  }

  return qaData.map((sectionData) => {
    if (!sectionData || !sectionData.questions || !Array.isArray(sectionData.questions)) {
      return {
        sectionId: sectionData?.section_id || '',
        title: sectionData?.title || '',
        questions: [],
      }
    }

    return {
      sectionId: sectionData.section_id || '',
      title: sectionData.title || '',
      questions: sectionData.questions.map((question) => ({
        questionId: question.question_id || '',
        questionTitle: question.question_title || '',
        aiQuestion: question.ai_question || '',
        aiAnswer: question.ai_answer || '',
        sectionId: question.section_id || '',
        riskLevel: question.risk_level || null,
      })),
    }
  })
}
